export abstract class SdkLoadService {
  abstract load(): Promise<void>;
}
